import * as React from 'react';
import styled from 'styled-components';
import { COLORS } from '../styles';
import { ListRowDropdownOption } from '../types';

const Wrapper = styled.div`
  .isInside {
    top: 42px;
  }
  .isOutside {
    bottom: 42px;
  }
`;

const DropdownMenuContainer = styled.div`
  position: absolute;
  flex-direction: column;
  background: ${COLORS.white};
  font-size: 1em;
  z-index: 1;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  right: 0;
  width: max-content;
  min-width: 260px;
`;

const Content = styled.button`
  min-width: 100%;
  padding: 12px 16px;

  text-align: left;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  height: 48px;
  color: ${COLORS.neutral_600};

  background-color: ${COLORS.white};
  border-width: 0;

  &:hover,
  &:focus {
    cursor: pointer;
  }

  &:hover {
    background: ${COLORS.primary_20};
    border-radius: 4px;
  }
  &:active {
    background: ${COLORS.primary_100};
    border-radius: 4px;
  }
`;

type DropdownMenuProps = {
  options: ListRowDropdownOption[];
  closeDropdown: any;
};

const ListRowDropdown: React.FunctionComponent<DropdownMenuProps> = ({ options, closeDropdown }: DropdownMenuProps) => {
  const [classname, setClassname] = React.useState('isInside');
  const reference = React.useRef<HTMLDivElement>(null);

  const clickIsOutside = (e: any) => reference && reference?.current && !reference?.current.contains(e.target);

  const handleClick = (e: any) => {
    if (e.keyCode) {
      if (e.keyCode === 27) {
        closeDropdown();
      }
    } else if (clickIsOutside(e)) {
      closeDropdown();
    }
  };

  const isInViewport = (offset = 0) => {
    if (!reference.current) return;
    const top = reference.current.getBoundingClientRect().bottom;
    const inside = top + offset >= 0 && top - offset <= window.innerHeight;
    if (!inside) {
      setClassname('isOutside');
    }
  };

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClick, false);
    document.addEventListener('keydown', handleClick, false);
    isInViewport();
    return () => {
      document.removeEventListener('mousedown', handleClick, false);
      document.removeEventListener('keydown', handleClick, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrapper>
      <DropdownMenuContainer ref={reference} className={classname}>
        {options.map(option => (
          <Content key={option.key} onClick={option.action}>
            {option.label}
          </Content>
        ))}
      </DropdownMenuContainer>
    </Wrapper>
  );
};

export default ListRowDropdown;
